import React from 'react';
import range from 'lodash/range';

import LocalizedDayjs from 'common/localized_dayjs';
import * as f from 'common/components/Form';
import * as m from '../../messages';
import LocationSearchInput from 'common/components/LocationSearchInput';
import { formatZipcode } from 'common/formatters/ZipCode';

const option = (v, l) => ({ value: v, label: l });
const selectOption = n => option(n, n);
const zeroPad = n => `0${n}`.slice(-2);
const zeroPaddedRange = n => range(1, n + 1).map(zeroPad);
const zeroPaddedRangeOptions = n => zeroPaddedRange(n).map(selectOption);

const upperBound = minRequiredAge =>
  new Date().getFullYear() - (minRequiredAge - 1);

const yearOptions = props => {
  const upperBoundAge =
    props.selectedValue && props.disabled
      ? parseInt(props.selectedValue) + 1
      : upperBound(props.minRequiredAge);

  return range(1901, upperBoundAge)
    .map(String)
    .map(selectOption)
    .reverse();
};

const locale = LocalizedDayjs.findCorrectLocale(translations.locale);
LocalizedDayjs.locale(locale);
const months = LocalizedDayjs.getShortMonths();

const monthOptions = months
  .map((m, i) => [zeroPad(i + 1), m])
  .map(m => option(m[0], m[1]));

export const Month = props => (
  <f.TranslatedField
    name="month"
    type="text"
    component={f.Select}
    placeholder={m.PLACEHOLDER_MONTH}
    options={monthOptions}
    {...props}
  />
);

export const Day = props => (
  <f.TranslatedField
    name="day"
    type="text"
    component={f.Select}
    placeholder={m.PLACEHOLDER_DAY}
    options={zeroPaddedRangeOptions(31)}
    {...props}
  />
);

export const Year = props => (
  <f.TranslatedField
    name="year"
    type="text"
    component={f.Select}
    placeholder={m.PLACEHOLDER_YEAR}
    options={yearOptions(props)}
    {...props}
  />
);

export const FirstName = props => (
  <f.TranslatedField
    name="first_name"
    type="text"
    component={f.Input}
    label={m.LABEL_FIRST_NAME}
    {...props}
  />
);

export const LastName = props => (
  <f.TranslatedField
    name="last_name"
    type="text"
    component={f.Input}
    label={m.LABEL_LAST_NAME}
    {...props}
  />
);

export const Address1 = ({ labelKey, ...props }) => (
  <LocationSearchInput labelKey={labelKey} {...props} />
);

export const Address2 = props => (
  <f.TranslatedField
    name="address2"
    type="text"
    component={f.Input}
    label={m.LABEL_ADDRESS_2}
    {...props}
  />
);

export const City = props => (
  <f.TranslatedField
    name="city"
    type="text"
    component={f.Input}
    label={m.LABEL_CITY}
    {...props}
  />
);

export const States = props => (
  <f.TranslatedField
    name="state"
    component={f.Select}
    options={gon.CURRENT_COUNTRY_STATES}
    placeholder={m.PLACEHOLDER_STATE}
    noResultsText={m.ERROR_NO_SUCH_STATE}
    {...props}
  />
);

export const Zip = props => (
  <f.ZipCode
    name="zip"
    type="text"
    component={f.Input}
    label={m.LABEL_ZIP}
    format={value => {
      return formatZipcode(value, gon.current_store.cart_tax_country_iso);
    }}
    {...props}
  />
);

export const Country = props => {
  return (
    <f.TranslatedField
      name="country"
      type="hidden"
      component={f.Input}
      {...props}
    />
  );
};

export const SSN = props => (
  <f.TranslatedField
    name="national_id_number"
    label={m.LABEL_SSN}
    type="text"
    component={f.Input}
    {...props}
  />
);

export const NationalIDNType = props => (
  <f.TranslatedField
    name="national_id_number_type"
    type="hidden"
    component={f.Input}
    {...props}
  />
);

export const SSNOptOut = props => (
  <f.TranslatedField
    name="national_id_number_optout"
    label={m.LABEL_SSN_OPTOUT}
    component={f.Checkbox}
    {...props}
  />
);

export const Gender = props => (
  <f.TranslatedField name="gender" component={f.Select} {...props} />
);

export const TaxCode = props => (
  <f.TranslatedField
    name="national_id_number"
    label={m.LABEL_TAX_CODE}
    type="text"
    component={f.Input}
    {...props}
  />
);

export const SSNRadio = props => (
  <f.TranslatedField
    name="national_id_number_optout"
    id={m.LABEL_SSN_OPTOUT}
    component={f.Radio}
    parse={() => false}
    {...props}
  />
);

export const SSNOptOutRadio = props => (
  <f.TranslatedField
    name="national_id_number_optout"
    id={m.LABEL_SSN}
    component={f.Radio}
    parse={() => true}
    {...props}
  />
);

export const PassportNumber = props => (
  <f.TranslatedField
    name="national_id_number"
    label={m.LABEL_PASSPORT_NUMBER}
    type="text"
    component={f.Input}
    {...props}
  />
);
